// Date helpers mirroring the Flutter app's local-time `yyyy-MM-dd` keys.

const pad = (n, w = 2) => String(n).padStart(w, '0');

export function dateKey(d = new Date()) {
  return `${pad(d.getFullYear(), 4)}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

/** `yyyy-MM-ddTHH:mm:ss` in local time (body progress doc ids). */
export function dateTimeKey(d = new Date()) {
  return `${dateKey(d)}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

/** `yyyy-MM-ddTHH:mm:ss` in UTC (history map keys). */
export function utcTimestampKey(d = new Date()) {
  return `${pad(d.getUTCFullYear(), 4)}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())}T${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
}

/** ISO UTC without millis, with Z (nutrition created_at). */
export function isoNowZ() {
  return `${new Date().toISOString().split('.')[0]}Z`;
}

export function parseDateKey(str) {
  if (!str) return null;
  const only = String(str).split('T')[0];
  const [y, m, d] = only.split('-').map((x) => parseInt(x, 10));
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
}

export function startOfDay(d = new Date()) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function addDays(d, n) {
  const r = new Date(d);
  r.setDate(r.getDate() + n);
  return r;
}

export function isSameDay(a, b) {
  return a && b && a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

/** ISO weekday: 1 = Monday … 7 = Sunday (Dart's DateTime.weekday). */
export function isoWeekday(d) {
  const w = d.getDay();
  return w === 0 ? 7 : w;
}

export function mondayOf(d = new Date()) {
  const s = startOfDay(d);
  return addDays(s, -(isoWeekday(s) - 1));
}

export function weekDates(d = new Date()) {
  const m = mondayOf(d);
  return Array.from({ length: 7 }, (_, i) => addDays(m, i));
}

export function formatDate(d, locale, opts = { day: 'numeric', month: 'short', year: 'numeric' }) {
  if (!d) return '';
  return d.toLocaleDateString(locale, opts);
}

export function formatTime(d, locale) {
  if (!d) return '';
  return d.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
}

export function tsToDate(v) {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (typeof v.toDate === 'function') return v.toDate();
  if (typeof v === 'string') {
    const d = new Date(v);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

/** UTC 15-minute slot (0-95) for a local minute of day — keep in sync with reminderUtcSlot() in user_model.dart. */
export function reminderUtcSlot(localMinute) {
  const offset = -new Date().getTimezoneOffset();
  return Math.floor((((localMinute - offset) % 1440) + 1440) % 1440 / 15);
}

export function minuteToHHMM(m) {
  return `${pad(Math.floor(m / 60))}:${pad(m % 60)}`;
}

export function hhmmToMinute(s) {
  const [h, m] = String(s).split(':').map((x) => parseInt(x, 10));
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  const total = h * 60 + m;
  return total - (total % 15);
}
